export const requiredValidatorKeys = [
    'invalidValue',
    'required',
    'isnotoneofcomponentdynamiclistbyid'
];
